function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from "react";
import { RemoteComponent } from "../RemoteComponent";
import { ErrorBoundary } from "../utilities/ErrorBoundary";
import { useMboxCache } from "./cache/mboxes";
import { isDebugging } from "../../utils/debug";
var debugging = isDebugging([
    "lapel-adobe-debugger"
]);
/**
 * @desc wraps the component in a remote component along with an AdobeTarget mbox taken from props
 */ var withDebugger = function(AdobeTarget) {
    if (!debugging) return AdobeTarget;
    var WithDebugger = /*#__PURE__*/ forwardRef(function(props, ref) {
        var mbox = props.mbox, mboxParams = props.mboxParams, name = props.name, parameters = props.parameters;
        var _useMboxCache = useMboxCache({
            name: name || mbox,
            parameters: parameters || mboxParams
        }), _useMboxCache_cachedMbox = _useMboxCache.cachedMbox, cachedMbox = _useMboxCache_cachedMbox === void 0 ? {} : _useMboxCache_cachedMbox;
        var child = /*#__PURE__*/ _jsx(AdobeTarget, _extends({}, props, {
            ref: ref
        }));
        return /*#__PURE__*/ _jsx(ErrorBoundary, {
            name: props.name,
            fallback: child,
            children: /*#__PURE__*/ _jsx(RemoteComponent, {
                props: {
                    cachedMbox: cachedMbox,
                    AdobeTarget: AdobeTarget,
                    props: props
                },
                remote: "abtFederationHost",
                component: "utils/AdobeTargetInspector",
                ref: ref,
                children: child
            })
        });
    });
    WithDebugger.displayName = "WithDebugger";
    return WithDebugger;
};
export { withDebugger };

//# sourceMappingURL=RemoteDebugger.js.map